module.exports = __webpack_public_path__ + "static/media/daily-goal-bg.b2785c48.png";